import { signedFetch } from '../../super-picker/services/api';

const BASE = '/api/super-calculator/whats-new';

/** Which calculators publish release notes — matches the backend whitelist. */
export type WhatsNewCalculator = 'buying' | 'selling' | 'maximizer' | 'decoupling';

export interface WhatsNewSeenState {
  /** Newest release version the agent has closed. '' when they have seen none. */
  seenVersion: string;
  /** They ticked "Don't show this again" — never auto-open, whatever the version. */
  suppressed: boolean;
}

/**
 * Read every calculator's acknowledgement for the signed-in agent.
 *
 * Returns null when the state could not be read, which the caller treats as "don't
 * interrupt" — showing the dialog on a failed read would pop it on every page load
 * whenever the backend is unreachable.
 */
export async function fetchWhatsNewState(): Promise<Partial<Record<WhatsNewCalculator, WhatsNewSeenState>> | null> {
  try {
    // redirectOnAuthError: false — a release note must never bounce the agent to
    // /unauthorized mid-case just because this one call came back 401.
    const response = await signedFetch(BASE, undefined, true, false);
    if (!response.ok) return null;
    return await response.json();
  } catch (error) {
    console.error('Failed to read What\'s New state:', error);
    return null;
  }
}

/** Record that the agent closed the notes, and whether they asked not to see them again. */
export async function saveWhatsNewState(
  calculator: WhatsNewCalculator,
  patch: Partial<WhatsNewSeenState>,
): Promise<boolean> {
  try {
    const response = await signedFetch(
      `${BASE}/${calculator}`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(patch),
      },
      true,
      false,
    );
    return response.ok;
  } catch (error) {
    console.error('Failed to save What\'s New state:', error);
    return false;
  }
}
